import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { site } from "../config/site";

export default function MobileActionBar() {
  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-white/10 bg-ink text-ivory lg:hidden"
      aria-label="Quick contact actions"
      data-testid="mobile-action-bar"
    >
      <a
        href={site.phoneHref}
        data-testid="mobile-call-btn"
        className="flex min-h-[60px] flex-col items-center justify-center gap-1 text-[10px] font-semibold uppercase tracking-[0.18em] transition-colors active:bg-white/5"
      >
        <Phone className="h-4 w-4 text-champagne" />
        Call
      </a>
      <a
        href={site.whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="mobile-whatsapp-btn"
        className="flex min-h-[60px] flex-col items-center justify-center gap-1 border-x border-white/10 text-[10px] font-semibold uppercase tracking-[0.18em] transition-colors active:bg-white/5"
      >
        <MessageCircle className="h-4 w-4 text-champagne" />
        WhatsApp
      </a>
      <Link
        to="/book"
        data-testid="mobile-book-btn"
        className="flex min-h-[60px] flex-col items-center justify-center gap-1 bg-champagne text-[10px] font-semibold uppercase tracking-[0.18em] text-ink transition-colors active:bg-champagne-dark"
      >
        <CalendarCheck className="h-4 w-4" />
        Book
      </Link>
    </nav>
  );
}
